export default __webpack_public_path__ + "static/media/work-2.c3f434ce.png";